import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import type { TrackId } from 'types/track'
import { getOrFetchTrack } from '@disco/state-management/actions/PlaylistTrackActions'
import { getTrack } from '@disco/state-management/selectors/tracks'
import DocumentHeadTags from 'components/document-head-tags'
import { getRoutingPreviousLocation } from '@disco/state-management/selectors/routing'
import TrackStatsModal from 'components/modals/track/stats'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import Spinner from 'components/ui/spinner'
import { getModalBestReturnTo } from '@disco/utils/modals'

const TrackStats = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ trackId: string }>()
  const trackIdStr = params.trackId!
  const trackId = parseInt(trackIdStr, 10) as TrackId
  const track = useSelector(state =>
    getTrack(state, {
      id: trackId,
    }),
  )
  const previousLocation: Location | null | undefined = useSelector(
    getRoutingPreviousLocation,
  )

  const onClose = () => {
    const returnTo = getModalBestReturnTo(location, previousLocation)
    navigate(returnTo)
  }

  useEffect(() => {
    if (!track) {
      dispatch(getOrFetchTrack(trackId))
    }
  }, [])

  if (!track) {
    return (
      <>
        <DocumentHeadTags title="Track stats | DISCO" />
        <ModalWindow
          header={<Heading size="700">Track Stats</Heading>}
          width="medium"
          onClose={onClose}
          isOpen
        >
          <Spinner />
        </ModalWindow>
      </>
    )
  }

  return (
    <>
      <DocumentHeadTags title="Track stats | DISCO" />
      <TrackStatsModal track={track} onClose={onClose} />
    </>
  )
}

export default TrackStats
